import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Grid, Typography } from 'components/base';
import { formatDuration } from 'utils/format';
import syncApi from 'ecommerce/api/sync';
import sleep from 'utils/sleep';

const DraftSyncOutdated = props => {
  const [newDraft, setNewDraft] = useState();

  const [lastModified, setLastModified] = useState(formatDuration(props.lastModifiedOnServer));
  useEffect(() => {
    const intervalId = setInterval(() => {
      setLastModified(formatDuration(props.lastModifiedOnServer));
    }, [1000]);
    return () => {
      clearInterval(intervalId);
    };
  }, [props.lastModifiedOnServer]);

  const handleOnBackupThisCreationClick = async e => {
    e.preventDefault();

    const response = await syncApi(props.accessToken).saveProductDraft(
      props.item.productId,
      props.template.templateUrl,
      props.template.version,
      props.data,
      `Backup of ${props.item.draftName}`,
    );

    setNewDraft(response);
  };

  const handleOnReloadThisCreationClick = async e => {
    e.preventDefault();
    window.location.reload();
    await sleep(10000);
  };

  return (
    <>
      <Typography.P className="mb-2">
        We encountered an error saving your project <strong>(id: {props.item.draftId})</strong>. The
        version saved is newer than the one you are attempting to save. We saved your project in our
        system approximately <strong>{lastModified}</strong> ago.
      </Typography.P>
      <Typography.P className="mb-2">
        This could happen if you have been working on the same creation from multiple locations at
        the same time, or in a different browser window. This could also happen if there was a
        problem with your internet connection.
      </Typography.P>
      <Typography.P className="mb-2">
        We recommend you first save this version of your creation as a backup. Once that is done -
        you should load latest saved version to continue working on it.
      </Typography.P>

      <Grid.Row>
        <Grid.Col xs={6}>
          <Button
            block
            type={newDraft?.data == null ? 'primary' : 'secondary'}
            disabled={newDraft?.data != null}
            onClick={handleOnBackupThisCreationClick}
          >
            Step 1: Backup This Creation
          </Button>
        </Grid.Col>
        <Grid.Col xs={6}>
          <Button
            block
            type={newDraft?.data != null ? 'primary' : 'secondary'}
            onClick={handleOnReloadThisCreationClick}
          >
            Step 2: Load Latest Version
          </Button>
        </Grid.Col>
      </Grid.Row>

      {newDraft?.data && (
        <Typography.P className="mt-2 text-success">
          We have successfully backed up this creation with{' '}
          <strong>(id: {newDraft.data.id})</strong> and you will be able to access it in{' '}
          <strong>My Projects</strong>.
        </Typography.P>
      )}

      {newDraft?.error && (
        <Typography.P className="mt-2 text-danger">
          Oops, something went wrong. Please try again.
        </Typography.P>
      )}
    </>
  );
};

DraftSyncOutdated.propTypes = {
  accessToken: PropTypes.string,
  lastModifiedOnClient: PropTypes.object,
  lastModifiedOnServer: PropTypes.object,
  item: PropTypes.object,
  template: PropTypes.object,
  data: PropTypes.object,
};

export default DraftSyncOutdated;
